import { FC } from 'react';
import Typography from '@/components/shared/typography/typography.component';
import myImageLoader from '@/image.local.loader';

interface IStep {
    src: { src: string };
    title: string;
    subtitle: string;
}

export const BannerStep: FC<IStep> = ({ src, title, subtitle }) => {
    return (
        <div
            className={
                'bg-gray-50 rounded-lg pe-3 p-4 pt-12 flex  gap-2 flex-col items-start  justify-start  md:h-[300px]'
            }
        >
            <div className={'min-w-[148px] min-h-[112px] flex'}>
                <img
                    alt={'purchase-car'}
                    src={myImageLoader({
                        src: src.src,
                        height: 112,
                    })}
                    className={'w-[148px] object-fill'}
                />
            </div>
            <div className={'flex flex-col gap-1.5 items-start'}>
                <Typography
                    variant={'body1SemiBold'}
                    className={'text-gray-800'}
                >
                    {title}
                </Typography>
                <Typography
                    variant={'caption'}
                    className={'text-primary-700'}
                    component={'span'}
                >
                    <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                </Typography>
            </div>
        </div>
    );
};
